import {createContext} from 'react';

export const SelectedModuleIdContext = createContext(null);
